import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import logo from "../../assets/images/mmt/logo.png";
import prelogin from "../../assets/images/mmt/prelogin.png";
import resetBg from "../../assets/images/mmt/bg-reset-password.png";
import { loginMmt } from "../mmtUserList/mmtApi";
import { buildSessionPath, setStoredSession } from "../mmtUserList/mmtFlow";
import {
  ADMIN_CHOICE,
  FORGOT_PASSWORD,
  USER_LIST,
} from "../../routes/routerPath";
import { pageLocale } from "../../utlis/locale";
import "./mmtlogin.scss";

const EMAIL_REGEX = /^\s*[a-z0-9._+-]+@[a-z0-9.-]+\.[a-z]{2,}\s*$/i;

export default function MmtLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const t = pageLocale("mmtLogin");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [expiredEmail, setExpiredEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const goToPasswordReset = (emailToReset = email.trim(), autoSend = false) => {
    navigate(FORGOT_PASSWORD, {
      state: {
        email: emailToReset,
        autoSend,
      },
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmedEmail = email.trim();
    if (!EMAIL_REGEX.test(trimmedEmail)) {
      setError(t.error_invalid_email);
      return;
    }
    if (!password) {
      setError(t.error_missing_password);
      return;
    }

    setLoading(true);
    setError("");
    setExpiredEmail("");
    try {
      const { session } = await loginMmt(trimmedEmail, password);
      session.locale = searchParams.get("locale") || session.locale || "en";
      setStoredSession(session);
      const target =
        session.role === "ADMIN"
          ? ADMIN_CHOICE
          : buildSessionPath(USER_LIST, session);
      navigate(target, { replace: true });
    } catch (err) {
      if (err?.isPasswordExpired) {
        setExpiredEmail(trimmedEmail);
        setError(t.error_password_expired);
      } else {
        setError(err?.message || t.error_invalid_credentials);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="mmt-login-page">
      <section className="mmt-login-scroll">
        <div className="mmt-login-shell">
          <div className="mmt-login-art">
            <img src={logo} alt="Senior Life" className="mmt-login-logo" />
            <img src={prelogin} alt="" className="mmt-login-prelogin" />
          </div>

          <form className="mmt-login-card" onSubmit={handleSubmit}>
            <h1>{t.title}</h1>
            {error ? (
              <div className="mmt-login-error">
                <span>{error}</span>
                {expiredEmail ? (
                  <div className="mmt-login-error-actions">
                    <button
                      type="button"
                      onClick={() => goToPasswordReset(expiredEmail, true)}
                    >
                      {t.reset_password}
                    </button>
                  </div>
                ) : null}
              </div>
            ) : null}

            <label className="mmt-field">
              <span>{t.email_label}</span>
              <input
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                  setError("");
                  setExpiredEmail("");
                }}
                inputMode="email"
                autoComplete="email"
                disabled={loading}
              />
            </label>

            <label className="mmt-field">
              <span>{t.password_label}</span>
              <div className="mmt-password-wrap">
                <input
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    setError("");
                    setExpiredEmail("");
                  }}
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  disabled={loading}
                />
                <button
                  type="button"
                  className="mmt-icon-button"
                  onClick={() => setShowPassword((value) => !value)}
                  aria-label={showPassword ? t.hide_password : t.show_password}
                >
                  {showPassword ? t.hide : t.show}
                </button>
              </div>
            </label>

            <button
              type="button"
              className="mmt-text-link"
              onClick={() => goToPasswordReset(email.trim())}
            >
              {t.forgot_password}
            </button>

            <button
              className="mmt-primary-button"
              type="submit"
              disabled={loading}
            >
              {loading ? t.submitting : t.submit}
            </button>

            <p className="mmt-new-user">
              <strong>{t.new_user}</strong>{" "}
              <button type="button" onClick={() => navigate("/signup")}>
                {t.sign_up}
              </button>
            </p>
          </form>
        </div>
      </section>
      <img src={resetBg} alt="" className="mmt-login-bg" />
    </main>
  );
}
